var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _line9, _line10, _g11, _g12, _g13, _g14, _line11, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopSIdeContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1329 446.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 57.518,
    y1: 103.13,
    x2: 1308.527,
    y2: 105.13,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 57.623,
    y1: 434.546,
    x2: 1309.058,
    y2: 436.546,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1307.955,
    y1: 103.571,
    x2: 1307.955,
    y2: 435.998,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 58.013,
    y1: 103.605,
    x2: 58.013,
    y2: 435.972,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 58.288,
    y1: 379.492,
    x2: 124.218,
    y2: 435.93,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 1241.03,
    y1: 436.94,
    x2: 1306.96,
    y2: 380.502,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 1242.881,
    y1: 104.221,
    x2: 1308.811,
    y2: 160.658,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 56.54,
    y1: 160.878,
    x2: 122.469,
    y2: 104.44,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 184.635,
    y1: 108.266,
    x2: 184.635,
    y2: 114.266,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.635,
    y1: 126.652,
    x2: 184.635,
    y2: 417.736,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.635,
    y1: 423.93,
    x2: 184.635,
    y2: 429.93,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 308.869,
    y1: 109.018,
    x2: 308.869,
    y2: 115.018,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308.869,
    y1: 127.405,
    x2: 308.869,
    y2: 418.489,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308.869,
    y1: 424.682,
    x2: 308.869,
    y2: 430.682,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 437.265,
    y1: 108.648,
    x2: 437.265,
    y2: 114.648,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 437.265,
    y1: 127.034,
    x2: 437.265,
    y2: 418.118,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 437.265,
    y1: 424.312,
    x2: 437.265,
    y2: 430.312,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 561.334,
    y1: 108.92,
    x2: 561.334,
    y2: 114.92,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 561.334,
    y1: 127.306,
    x2: 561.334,
    y2: 418.39,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 561.334,
    y1: 424.583,
    x2: 561.334,
    y2: 430.583,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 685.884,
    y1: 108.516,
    x2: 685.884,
    y2: 114.516,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 685.884,
    y1: 126.903,
    x2: 685.884,
    y2: 417.987,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 685.884,
    y1: 424.18,
    x2: 685.884,
    y2: 430.18,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 810,
    y1: 109.043,
    x2: 810,
    y2: 115.043,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 810,
    y1: 127.43,
    x2: 810,
    y2: 418.514,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 810,
    y1: 424.707,
    x2: 810,
    y2: 430.707,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 938.232,
    y1: 109.154,
    x2: 938.232,
    y2: 115.154,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 938.232,
    y1: 127.54,
    x2: 938.232,
    y2: 418.624,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 938.232,
    y1: 424.817,
    x2: 938.232,
    y2: 430.817,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1062.656,
    y1: 109.507,
    x2: 1062.656,
    y2: 115.507,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1062.656,
    y1: 127.894,
    x2: 1062.656,
    y2: 418.977,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1062.656,
    y1: 425.171,
    x2: 1062.656,
    y2: 431.171,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1186.896,
    y1: 109.876,
    x2: 1186.896,
    y2: 115.876,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1186.896,
    y1: 128.262,
    x2: 1186.896,
    y2: 419.346,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.387 12.387",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1186.896,
    y1: 425.54,
    x2: 1186.896,
    y2: 431.54,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1304.514,
    y1: 273.941,
    x2: 1298.514,
    y2: 273.941,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1286.575,
    y1: 273.941,
    x2: 74.788,
    y2: 273.941,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 11.939 11.939",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.819,
    y1: 273.941,
    x2: 62.819,
    y2: 273.941,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 60.024,
    y1: 6.423,
    x2: 60.024,
    y2: 98.321,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 1311.555,
    y1: 6.683,
    x2: 1311.555,
    y2: 101.463,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 88.249,
    y1: 51.796,
    x2: 344.76,
    y2: 51.796,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.085 71.741 59.545 51.796 94.085 31.85 94.085 71.741"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 657.924,
    y1: 52.91,
    x2: 426.407,
    y2: 52.91,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "652.088 32.965 686.629 52.91 652.088 72.855 652.088 32.965"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 88.266,
    y1: 29.154,
    x2: 970.515,
    y2: 29.154,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.102 49.1 59.561 29.154 94.102 9.209 94.102 49.1"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1285.002,
    y1: 29.398,
    x2: 1057.121,
    y2: 29.398,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1279.166 9.452 1313.707 29.398 1279.166 49.343 1279.166 9.452"
  }))), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 685.716,
    y1: 34.649,
    x2: 685.716,
    y2: 99.751,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(112.687 93.803)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(232.378 93.324)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(353.214 93.505)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(473.28 93.572)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(593.104 93.389)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(712.934 93.017)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(832.804 93.394)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(957.764 93.65)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(1073.67 93.456)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "9"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(1197.457 93.307)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(17.253 212.364)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30,
    letterSpacing: "-.037em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(17.636 355.543)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(354.894 55.098)",
    fontFamily: "ArialMT, Arial",
    fontSize: 29,
    letterSpacing: ".055em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "20ft"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(986.369 37.772)",
    fontFamily: "ArialMT, Arial",
    fontSize: 29,
    letterSpacing: ".055em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "40ft"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopSIdeContainer);
export default __webpack_public_path__ + "static/media/Top SIde Container.356790a1fa4ce4d0b08d4e38ea648216.svg";
export { ForwardRef as ReactComponent };